import {ViewPopupLanguage} from '../ViewPopupLanguage.ts'
import {setElementInnerText, setElementOnClick} from '../../ui_utils/DomUtils.ts'
import {createTooltipIn} from '../../ui_utils/TooltipUtils.ts'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables.ts'

export class UILanguageButtonController {
    constructor(container: HTMLDivElement) {
        const languageButton = container.getElementsByClassName('language-button')[0] as HTMLDivElement | undefined
        if(languageButton == undefined) return

        setElementOnClick(languageButton, () => {
            new ViewPopupLanguage()
        })
        createTooltipIn(languageButton, {key: 'strings:homePage.footer.changeLanguageButtonTooltip'}, 'top', undefined, 'small')
        const languageTextDiv = languageButton.querySelector('div')
        if(!languageTextDiv) return
        setElementInnerText(languageTextDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: UIUtilsEjsVariables.language}})
    }
}

